import store from '../store'

const CAPTCHA_SCRIPT = "https://www.google.com/recaptcha/api.js"

const applyCaptcha = (captchaKey) => {
    store.dispatch('updateCaptchaKey', captchaKey)

    const element = document.createElement("script")
    element.src = CAPTCHA_SCRIPT + "?render=" + captchaKey
    document.head.appendChild(element)
}

const getCaptchaToken = (action) => {
    const captchaKey = store.getters['captchaKey']

    if (!captchaKey) {
        return Promise.reject()
    }

    return new Promise((resolve, reject) => {
        window.grecaptcha.ready(() => {
            window.grecaptcha.execute(captchaKey, {action: action}).then((token) => {
                resolve(token)
            })
        })
    })
}

export {applyCaptcha, getCaptchaToken}